import { jsxs as c, jsx as h } from "react/jsx-runtime";
const r = (l) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M46.857 35.743c-6.138 0-11.114 4.975-11.114 11.114 0 6.139 4.975 11.114 11.114 11.114 6.139 0 11.114-4.975 11.114-11.114 0-6.139-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117ZM33.746 46.857c0-.507.03-1.009.087-1.501h-11.9l.535 1.998h11.289c-.006-.165-.01-.331-.01-.496h-.001v-.001ZM36.618 38.678H21.811v.029l.527 1.969h12.959c.379-.707.822-1.376 1.32-1.998h.001ZM41.751 31.999h-19.94v.104l.508 1.894h19.967l-.535-1.998Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M35.851 53.975H16.017V25.053h18.974V10.024h12.991v23.771a13 13 0 0 1 3.996.993V6.028H32L12.022 21.957v32.014a4 4 0 0 0 4 4h23.887a13.212 13.212 0 0 1-4.058-3.996Zm-3.856-42.832v10.914H18.306l13.689-10.914Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M41.751 31.999h-19.94v.104l.508 1.894h19.967l-.535-1.998ZM47.736 49.856h-2.133c.732-.489 1.009-1.27 1.009-2.035 0-.098 0-.196-.016-.293h2.295v-1.791h-2.865c-.163-.424-.277-.798-.277-1.286 0-.863.602-1.27 1.254-1.27.846 0 1.303.569 1.319 1.562l2.133-.569c-.082-1.335-.977-3.012-3.483-3.012-2.279 0-3.581 1.611-3.581 3.207 0 .537.081.977.212 1.367h-.928v1.791h1.579c.033.179.065.358.065.537 0 .96-.667 1.628-1.693 1.986v1.921h5.437c1.807 0 3.028-1.352 3.028-3.19l-2.149-.13c0 .732-.52 1.205-1.205 1.205h-.001Z"
        }
      )
    ]
  }
);
export {
  r as AccountInCreditPositiveBalance
};
